package pl.nickers.match3

import com.russhwolf.settings.Settings

actual fun createDefaultSettings(): Settings = Settings()
